import { CmsReactComponent } from 'components/cms/CmsReactComponent';
import { ThreedWithAudioProps } from "./types";
import {
  EntryOptions,
  PropertyDefinition,
  PropertyMappingType,
} from "app/library/layout-builder";
import { MetaTypeEnum } from 'app/shared';

export class ThreedWithAudioDefinitions extends CmsReactComponent<ThreedWithAudioProps> {

  static schemaName = "threed-with-audio";

  static propertyDefinitions: PropertyDefinition[] = [
    {
      name: "audio",
      mapping: {
        type: PropertyMappingType.File,
      },
      text: "Arkaplanda çalınacak ses",
    },
    {
      name: "images",
      text: "Gösterilecek görseller",
      mapping: {
        type: PropertyMappingType.ArrayData,
        keys: [{
          mapping: {
            type: PropertyMappingType.Image,
          },
          name: "src",
          text: "Görsel",
        }],
      },
    },
  ];

  static options: EntryOptions = {
    meta: {
      use: true,
      allowedTypes: [MetaTypeEnum.File, MetaTypeEnum.MultiImage]
    },
    mappingFields: [
      {
        name: "audio",
        text: "Arkaplanda çalınacak ses",
        types: [MetaTypeEnum.File],
      },
      {
        name: "images",
        text: "Gösterilecek görseller",
        types: [MetaTypeEnum.MultiImage],
      },
    ],
  };
}
